import React from 'react'
import ReactDOM from 'react-dom'
import '../../assets/js/polyfill'

import FragmentWrapper from '../FragmentWrapper'
import AppContext from '../../components/AppContext/AppContext'
import Header from './Header'

import { THeaderState } from '../../server/headerMiddleware/headerMiddleware'

const state: THeaderState = JSON.parse(document.getElementById(`x-ui-fragment-header-state`)?.innerHTML ?? '{}')

ReactDOM.hydrate(
  <AppContext.Provider value={{ locale: state.locale }}>
    <FragmentWrapper assetsUrl={state.assetsUrl} assetHash={state.assetHash} name={'header'}>
      <Header navItems={state.navItems} tickers={state.tickers} />
    </FragmentWrapper>
  </AppContext.Provider>,
  document.getElementById('x-ui-fragment-header-root'),
)
